const validateFieldValue = (fieldName, value) => {
  const isNumericField = ['Forme', 'Echelle'].includes(fieldName);
  const isAgeReferentField = ['AgeReferentDelta', 'AgeReferentPourcentage'].includes(fieldName);
  const isDefaillanceField = ['TauxPanneExterne', 'DureeQuasiPanne'].includes(fieldName);

  let isValid = true;

  if (isNumericField) {
    isValid = value === '' || /^-?\d*\.?\d*$/.test(value);
  } else if (isAgeReferentField) {
    isValid = value === '' || (/^(\d+\.?\d*([eE][+-]?\d*)?)$/.test(value) && !/^(\d+\.?\d*[eE]\d+)$/.test(value));
  } else if (isDefaillanceField) {
    isValid = value === '' || /^\d+\.?\d*$/.test(value);
  }

  return isValid;
};

const validateIdentifier = (value) => {
  return value === '' || /^[a-zA-Z0-9][a-zA-Z0-9_<>=.\-+]*$/.test(value);
};

const validateFloatList = (value) => {
  return value === '' || /^(-?\d+\.?\d*|-)(\|-?\d+\.?\d*)*\|?$/.test(value);
};

export { validateFieldValue, validateIdentifier, validateFloatList };
